<template>
    <div class="w-100 text-right pr-2">
        {{
            Value != undefined && isFinite(Value) ? Intl.NumberFormat('fr-FR', {
                minimumFractionDigits: Header.MinDecimal,
                maximumFractionDigits: Header.MaxDecimal
            }).format(Value) : ''
        }}
    </div>
</template>

<script lang="ts">
import {Vue, Component, Prop} from 'vue-property-decorator';
import {HeaderDecimal} from "@/components/commons/Generics/GenericTable/GenericTableHeader";

@Component({})
export default class GenericTableDecimalCell extends Vue {
    /** Valeur */
    @Prop({default: () => ''})
    public Value!: number;

    @Prop()
    public Header!: HeaderDecimal;
}
</script>
<style scoped>

</style>